/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_5_AInputs */

const en_vc_onl_faq_5_a = /** @type {(inputs: Vc_Onl_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It can load on recent tablets, but the interface is designed for a mouse or trackpad and keyboard. For real work, use a desktop or laptop browser.`)
};

const zh_vc_onl_faq_5_a = /** @type {(inputs: Vc_Onl_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较新的平板可以加载，但界面是为鼠标、触控板和键盘设计的。正式使用请用电脑浏览器。`)
};

/**
* | output |
* | --- |
* | "It can load on recent tablets, but the interface is designed for a mouse or trackpad and keyboard. For real work, use a desktop or laptop browser." |
*
* @param {Vc_Onl_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_5_a = /** @type {((inputs?: Vc_Onl_Faq_5_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_5_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_5_a(inputs)
	return zh_vc_onl_faq_5_a(inputs)
});
export { vc_onl_faq_5_a as "vc.onl.faq.5.a" }